"use client";
import { cn } from "~/lib/utils";
import { openReferralLink } from "~/lib/referral";
import { useRouter } from "next/navigation";
export type ButtonVariant = "purple" | "sky" | "green"
interface ButtonProps {
  link: string;
  variant: ButtonVariant;
  useRefLink?: boolean;
  className?: string;
  utm_term?: string;
  queryParams?: Record<string, string | number>; 
  children?: React.ReactNode;
}
const variantClasses = {
  purple: "bg-purple-600 hover:bg-purple-700",
  sky: "bg-sky-600 hover:bg-sky-700",
  green: "bg-emerald-600 hover:bg-emerald-700",
};
const baseClasses =
  "z-20 rounded-xl px-6 py-3 cursor-pointer font-semibold text-white transition active:squish transition-all duration-150 ease-in-out";

export default function Button({
  children,
  link,
  variant,
  useRefLink,
  utm_term,
  queryParams,
  className,
}: ButtonProps) {
  const router = useRouter();
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    
    if (useRefLink) {
      openReferralLink(link, utm_term, queryParams);
    } else {
      let finalLink = link;
      if (queryParams && Object.keys(queryParams).length > 0) {
        const searchParams = new URLSearchParams(
          Object.entries(queryParams).map(([k, v]) => [k, String(v)])
        );
        finalLink += `?${searchParams.toString()}`;
      }
      router.push(finalLink);
    }
  };
  
  return (
    <button
      onClick={handleClick}
      className={cn(baseClasses, variantClasses[variant], className)}
    >
      {children}
    </button>
  );
}
